import { FormattedMessage } from 'react-intl';

import * as S from './styles';

const CareProviderAtualizationInfo: React.FC = () => (
  <S.Container>
    <S.StyledAlertCircle data-testid="alertCircle" />
    <S.InfoText data-testid="infoText">
      <FormattedMessage id="CARE_PROVIDER.PAGE.INFO.MESSAGE" />{' '}
      <S.InfoStrong>atendimento@wellz.com</S.InfoStrong>
    </S.InfoText>
  </S.Container>
);

export default CareProviderAtualizationInfo;
